<template>
    <div class="per-cent">
        <div class="year">{{perData.year}}</div>
        <div class="center">
            <span class="people"  :style="getPeoWidth">{{getPeo}}</span>
            <div class="wrap">
                    <div class="per" :style="getPeoStyle"></div>
                    <div class="per-h":style="getRatStyle"></div>
            </div>
        </div>

        <div class="rate">{{this.perData.percent.toFixed(1)}}%</div>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            perData:{
                type:Object,
                default(){
                    return {
                        year:2010,
                        people:631,
                        percent:3.4
                    }

                }
            },
        },
        data() {
          return {
              peo:0,
              rate:0,
              position:0,
              flag:true

          }
        },
        mounted() {
            let timer = setInterval(()=>{
                if(this.peo<this.perData.people){
                    this.peo += 25
                }
                else {
                    this.peo=this.perData.people
                    clearInterval(timer)
                }
                this.position = this.peo - 65
            },20)
            let timer1 =setInterval(()=>{
                if(this.rate<this.perData.percent){
                    this.rate += 1
                }
                else {
                    this.rate = (this.perData.percent+5).toFixed(1);
                    clearInterval(timer1)
                }
            })
        },
        computed: {
            getPeoWidth() {
                return {marginLeft:this.position/12+'%'}
            },
            getPeo() {
              return this.peo
            },
            getPeoStyle() {
                return {width:this.peo/12+'%'}
            },
            getRatStyle() {
                return {width:this.rate+'%'}
            }
        },
    }
</script>

<style scoped lang="less">
    .per-cent {
        display: flex;
        align-items: flex-end;
        margin-bottom: 14px;
        .year,.rate {
            padding: 0 20px;
            line-height: 20px;
            color: #313131;
        }
        .rate {
            color: #f2911d;
        }
        .center {
            flex: 1;
            .people {
                color: #126eac;
            }
        }
        .wrap {
            background: #dcdddd;
            height: 18px;
            display: flex;
            justify-content: space-between;
            .per {
                background: #126eac;
                width: 0;
            }
            .per-h {
                background: #f2911d;
                width: 0;
            }
        }
    }
</style>